import { render, staticRenderFns } from "./UserQuotes.vue?vue&type=template&id=c0aa65c4&scoped=true&"
import script from "./UserQuotes.vue?vue&type=script&lang=ts&"
export * from "./UserQuotes.vue?vue&type=script&lang=ts&"
import style0 from "./UserQuotes.vue?vue&type=style&index=0&id=c0aa65c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0aa65c4",
  null
  
)

export default component.exports